import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#inventory #company_id				{ width: 13rem;		}
			#inventory #input_id				{ width: 5rem; text-align: right;	}
			#inventory #warehouse_company_id	{ width: 13rem;		}
			#inventory #warehouse_id			{ width: 13rem;		}
			#inventory #location_id				{ width: 7.5rem;	}
			#inventory .product					{ width: 18rem;		}
			#inventory .packaging_gtin			{ width: 11rem;	}
			#inventory .packaging				{ width: 14rem;		}
			#inventory .lot						{ width: 8rem;		}
			#inventory .date					{ width: 7rem;		}
			#inventory .quantity				{ width: 4.5rem; text-align: right;	}
			#inventory .status					{ width: 8rem;		}
		</style>
		<form id="inventory" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="title">
				Conferência&nbsp;de&nbsp;Entrada
			</div>
			<div class="fsb mtm">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="input_id" type="text" disabled>
				</label>
				<label title="Empresa do armazém de recebimento">Destino<sup>*</sup>
					<input id="warehouse_company_id" type="text" list="companies" required>
				</label>
				<label title="Armazém de recebimento">Armazém<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Posição de recebimento no armazém">Posição<sup>*</sup>
					<input id="location_id" type="text" list="locations" required>
				</label>
				<label title="Programa da entrada (todos os produtos desta entrada ficarão nesse programa)">Programa<sup>*</sup>
					<input id="program_id" type="text" list="programs" required>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>GTIN emb.</th>
							<th>Embalagem</th>
							<th>Lote<sup>*</sup></th>
							<th>Data Fab<sup>*</sup></th>
							<th>Data Val<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
							<th>Bloquear</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<input id="id-0" type="hidden">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="GTIN da embalagem (bip no coletor preenche embalagem)">
								<input id="packaging_gtin-0" class="packaging_gtin" type="text" placeholder="Bipar">
							</td>
							<td title="Embalagem do produto (cadastro)">
								<input id="product_packaging_id-0" class="packaging" type="text" list="packagings-0">
							</td>
							<td title="Numeração do lote">
								<input id="lot_number-0" class="lot" type="text" required>
							</td>
							<td title="Data de fabricação">
								<input id="manufacture_date-0" class="date" type="text" required>
							</td>
							<td title="Data de validade">
								<input id="expiration_date-0" class="date" type="text" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Direcionar lote para quarentena?">
								<input id="is_blocked-0" type="checkbox">
							</td>
							<input id="status-0" type="hidden">
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#inventory',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#input_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#warehouse_company_id' }, types: [types.pubsub(), types.datalist()] },	
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#location_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_id'), types.obs_load_options('locations', { labels: ['address'], sep: '-', key: 'warehouse_company_id' })] },
		{ properties: { selector: '#program_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('programs', { labels: ['name'] })] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#id-0' }, types: [] },
		{ properties: { selector: '#product_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#packaging_gtin-0' }, types: [types.pubsub(), types.gtin(), types.obs_resolve_gtin_inventory()] },
		{ properties: { selector: '#product_packaging_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('product_id-0'), types.obs_load_packagings_inventory()] },
		{ properties: { selector: '#lot_number-0' }, types: [types.caps()] },
		{ properties: { selector: '#manufacture_date-0' }, types: [types.date()] },
		{ properties: { selector: '#expiration_date-0' }, types: [types.date(), types.obs_expiration_past_alert()] },
		{ properties: { selector: '#quantity-0' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#is_blocked-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#status-0' }, types: [] },
	]

};

